import { useQuery } from "@tanstack/react-query";
import { PlanningDepartmentExportService } from "../../../../../services/planning-department/export-warehouse";
import { useRouteMatch } from "react-router-dom";

export const useGetDetailRequests = () => {
  const { id } = useRouteMatch().params as any;

  const response = useQuery({
    queryKey: ["detail-request-export", id],
    queryFn: () => PlanningDepartmentExportService.getDetail(id),
    refetchOnMount:"always"
  });

  return response;
};
